/* Draft-theme only. Only signed photo service lines require this validator. No cart mutation. */
(() => {
  if(window.OTSPhotoV2Cart)return;
  const node=document.querySelector('[data-photo-v2-cart]');if(!node)return;
  const config=JSON.parse(node.textContent),route=p=>(window.Shopify?.routes?.root||'/')+p;
  // Only our own copy is rendered. Even an older backend, proxy or malformed
  // response must not expose its raw error/message (paths, traces, credentials).
  const messages={
    PHOTO_REFERENCE_UNAVAILABLE:'The saved photo details for a printing service in your cart are unavailable. To include photo printing, please add the music box and its services again from the product page, then remove the old set. Or remove only the affected printing service to continue without printing. Other items can stay in your cart.',
    PHOTO_CART_DUPLICATE:'There is more than one printing service for the same music box. Please remove the extra printing service and try again.',
    PHOTO_CART_MAIN_MISSING:'The music box for a printing service is no longer in your cart. Please add its music box again, or remove that printing service.',
    PHOTO_CART_MISMATCH:'A printing service no longer matches its music box. Please review this set and add it again from the music box page if needed.',
    PHOTO_CART_QUANTITY:'Printing quantity must match the music box quantity. Change it in your cart, or remove printing.',
    PHOTO_CART_CHANGED:'Your cart changed. Please review it and continue again.',
    PHOTO_TEMPORARY:"We couldn't check your photo printing right now. Your cart has not been changed. Please try again shortly. If this continues, contact service@onetinyshop.com."
  };
  const safeMessage=code=>Object.hasOwn(messages,code)?messages[code]:messages.PHOTO_TEMPORARY;
  class CartPhotoError extends Error {
    constructor(codes){super([...new Set(codes.map(safeMessage))].join('\n\n'));}
  }
  let busy=false,pass=false,hasPhotos=Boolean(config.hasPhotos);
  async function check(){
    const response=await fetch(route('cart.js'),{cache:'no-store'});if(!response.ok)throw Error('Could not check your cart. Please try again.');
    const cart=await response.json();
    if(!cart.items.some(i=>i.properties?._ots_print_role==='service')){hasPhotos=false;return;}
    const r=await fetch(config.api.replace(/\/$/,'')+'/api/photo-v2/cart/validate',{method:'POST',credentials:'omit',
      headers:{'content-type':'application/json'},body:JSON.stringify({shop:config.shop,items:cart.items.map(({key,id,product_id,variant_id,quantity,properties})=>({key,id,product_id,variant_id,quantity,properties}))}),
      signal:AbortSignal.timeout(20000)});
    const data=await r.json();if(!r.ok||data?.ok!==true){
      const codes=Array.isArray(data?.issues)?data.issues.map(i=>i?.code):[];
      throw new CartPhotoError(codes.length?codes:[data?.code]);
    }
    const latestResponse=await fetch(route('cart.js'),{cache:'no-store'});if(!latestResponse.ok)throw Error('Could not confirm your cart.');
    const latest=await latestResponse.json();
    if(JSON.stringify(latest.items.map(i=>[i.key,i.quantity]))!==JSON.stringify(cart.items.map(i=>[i.key,i.quantity])))throw new CartPhotoError(['PHOTO_CART_CHANGED']);
  }
  function notice(message){
    let box=document.querySelector('[data-photo-v2-cart-error]');
    if(!box){
      box=document.createElement('dialog');box.dataset.photoV2CartError='';box.setAttribute('aria-label','Check your photo printing');
      box.style.cssText='box-sizing:border-box;max-width:480px;width:calc(100% - 32px);max-height:calc(100% - 32px);overflow:auto;padding:24px;border:1px solid #344c3b;border-radius:10px;background:#fff;color:#23382d;line-height:1.5';
      const h=document.createElement('h2');h.textContent='Please check your print set';
      const p=document.createElement('p');p.id='photo-cart-error-description';p.style.whiteSpace='pre-line';
      box.setAttribute('aria-describedby',p.id);
      const b=document.createElement('button');b.textContent='Back to cart';b.style.cssText='padding:12px;min-height:44px';b.onclick=()=>box.close();
      const help=document.createElement('a');help.href='mailto:service@onetinyshop.com';help.textContent='Contact us';help.style.marginLeft='16px';
      box.append(h,p,b,help);document.body.append(box);
    }
    box.querySelector('p').textContent=message;box.showModal();
  }
  async function proceed(event,done){
    if(!hasPhotos)return;if(pass){pass=false;return;}
    event.preventDefault();event.stopImmediatePropagation();if(busy)return;
    busy=true;try{await check();done();}catch(error){notice(error instanceof CartPhotoError?error.message:messages.PHOTO_TEMPORARY);}finally{busy=false;}
  }
  document.addEventListener('submit',event=>{
    const form=event.target;
    if(form.matches('form[action*="/cart"]:not([action*="/cart/add"])')&&event.submitter?.name==='checkout')proceed(event,()=>{pass=true;form.requestSubmit(event.submitter);});
  },true);
  document.addEventListener('click',event=>{
    const a=event.target.closest('a[href]');if(!a)return;
    const url=new URL(a.href);if(url.origin===location.origin&&/\/checkout(?:\/|$)/.test(url.pathname))proceed(event,()=>location.assign(a.href));
  },true);
  window.OTSPhotoV2Cart={check};
  // Previews belong to an exact cart line KEY, not its variant or current row
  // index. Two print sets can share a variant but contain different photos.
  const previewCache=new Map();let refreshTimer,refreshVersion=0;
  function detailsFor(key){
    const matches=[];
    for(const link of document.querySelectorAll('.cart-item cart-remove-button a[href]')){
      const url=new URL(link.href,location.href);
      if(url.origin!==location.origin||! /\/cart\/change\/?$/.test(url.pathname)||url.searchParams.get('id')!==key)continue;
      const details=link.closest('.cart-item').querySelector('.cart-item__details');if(details)matches.push(details);
    }
    return [...new Set(matches)];
  }
  function orderPrintGroups(items){
    // Shopify's cart order is not the requested display order. Move existing
    // rows only: NEVER renumber native IDs/data-index or mutate the cart. Dawn
    // quantity/remove controls still address their original server line.
    const bundles=new Map();
    for(const item of items){
      const p=item.properties||{};
      if(!p._ots_print_bundle||!p._ots_print_signature||!['main','service'].includes(p._ots_print_role))continue;
      if(!bundles.has(p._ots_print_bundle))bundles.set(p._ots_print_bundle,[]);
      bundles.get(p._ots_print_bundle).push(item);
    }
    const groups=[];
    for(const lines of bundles.values()){
      const mains=lines.filter(i=>i.properties._ots_print_role==='main'),prints=lines.filter(i=>i.properties._ots_print_role==='service');
      if(mains.length!==1||prints.length!==1)continue;
      const main=mains[0],print=prints[0];
      if(main.properties._ots_print_signature!==print.properties._ots_print_signature)continue;
      const groupId=main.properties._customization_group_id;
      const peers=groupId?items.filter(i=>i.properties?._customization_group_id===groupId):[];
      const isEngraving=i=>i.properties?._engraving_service==='Yes'||i.properties?.['Engraving Service']==='Yes';
      const engraving=peers.filter(isEngraving),nonEngraving=peers.filter(i=>!isEngraving(i));
      const ordered=[main];
      if(engraving.length===1&&nonEngraving.length===1&&nonEngraving[0]===main)ordered.push(engraving[0]);
      ordered.push(print);groups.push(ordered.map(i=>i.key));
    }
    const containers=new Map();
    for(const item of items)for(const details of detailsFor(item.key)){
      const row=details.closest('.cart-item'),parent=row.parentElement;
      if(!containers.has(parent))containers.set(parent,new Map());
      const rows=containers.get(parent);
      rows.set(item.key,rows.has(item.key)?null:row); // Ambiguous markup: do not guess.
    }
    for(const [parent,rows] of containers){
      const membership=new Map();
      for(const keys of groups){
        const ordered=keys.map(key=>rows.get(key));
        if(ordered.some(row=>!row||membership.has(row)))continue;
        ordered.forEach(row=>membership.set(row,ordered));
      }
      const desired=[],seen=new Set();
      // Keep each group at its earliest existing position, preserving the
      // relative order of every unrelated item and every other print group.
      for(const row of parent.children){
        const group=membership.get(row);
        if(!group)desired.push(row);
        else if(!seen.has(group)){seen.add(group);desired.push(...group);}
      }
      desired.forEach((row,index)=>{if(parent.children[index]!==row)parent.insertBefore(row,parent.children[index]||null);});
    }
  }
  function previewBox(details,item){
    let box=details.querySelector('.ots-photo-v2-cart-preview');
    if(box?.dataset.lineKey!==item.key){box?.remove();box=null;}
    if(!box){
      box=document.createElement('section');box.className='ots-photo-v2-cart-preview';box.dataset.lineKey=item.key;
      box.setAttribute('aria-label','Your photo printing');details.append(box);
    }
    return box;
  }
  function simplifyDetails(details,item){
    // Presentation only: keep Shopify properties/order data and unrelated
    // variant options untouched, including older non-v2 printing purchases.
    const redundant=new Set(['how it works','photo printing','photo sizes','photo delivery']);
    for(const term of details.querySelectorAll('dl > .product-option > dt')){
      if(!redundant.has(term.textContent.trim().replace(/:\s*$/,'').toLowerCase()))continue;
      const row=term.parentElement;
      if(row.hidden)continue;
      row.dataset.otsPhotoV2HiddenFor=item.key;row.hidden=true;
    }
    for(const list of details.querySelectorAll(':scope > dl')){
      const empty=list.children.length&&[...list.children].every(row=>row.hidden);
      if(empty&&!list.hidden){list.dataset.otsPhotoV2HiddenFor=item.key;list.hidden=true;}
      else if(!empty&&list.dataset.otsPhotoV2HiddenFor){list.hidden=false;delete list.dataset.otsPhotoV2HiddenFor;}
    }
  }
  function showPreview(details,item,result){
    simplifyDetails(details,item);
    const box=previewBox(details,item);box.replaceChildren();
    const title=document.createElement('p');title.className='ots-photo-v2-cart-preview__title';
    title.textContent=!result.error&&result.mode==='email'?'Photos not provided yet':'Print preview';box.append(title);
    if(result.error||result.mode==='email'){
      const p=document.createElement('p');
      if(result.error)p.textContent=result.code==='PHOTO_REFERENCE_UNAVAILABLE'
        ?'Saved photo details are unavailable. Please review this printing service before checkout.'
        :"We couldn't load the print preview right now. Please retry shortly.";
      else{
        p.append('After placing your order, please email your photos to ');
        const link=document.createElement('a');link.href='mailto:service@onetinyshop.com';link.textContent='service@onetinyshop.com';
        p.append(link,'.');
      }
      box.append(p);
      if(result.error){
        const retry=document.createElement('button');retry.type='button';retry.textContent='Retry preview';
        retry.onclick=()=>{previewCache.delete(identity(item));schedulePreviews();};box.append(retry);
      }
      return;
    }
    const list=document.createElement('div');list.className='ots-photo-v2-cart-preview__photos';
    for(const photo of result.photos||[]){
      if(typeof photo.src!=='string'||!/^data:image\/jpeg;base64,[A-Za-z0-9+/=]+$/.test(photo.src))continue;
      const figure=document.createElement('figure'),img=document.createElement('img'),caption=document.createElement('figcaption');
      img.src=photo.src;img.alt='Saved print crop · '+photo.label;img.loading='lazy';img.decoding='async';
      img.width=180;img.height=120;
      caption.textContent=photo.label+' · '+photo.widthMm+' × '+photo.heightMm+' mm';
      img.onerror=()=>{img.hidden=true;caption.textContent+=' · Preview could not load';};
      figure.append(img,caption);list.append(figure);
    }
    box.append(list);
  }
  function identity(item){return item.properties._ots_print_bundle+':'+item.properties._ots_print_signature;}
  function schedulePreviews(){refreshVersion++;clearTimeout(refreshTimer);refreshTimer=setTimeout(refreshPreviews,120);}
  async function refreshPreviews(){
    if(!document.querySelector('.cart-item__details'))return;
    const version=refreshVersion;
    try{
      const response=await fetch(route('cart.js'),{cache:'no-store',signal:AbortSignal.timeout(15000)});
      if(!response.ok)throw Error('Could not read cart.');
      const cart=await response.json();if(version!==refreshVersion)return;
      orderPrintGroups(cart.items);
      hasPhotos=cart.items.some(i=>i.properties?._ots_print_role==='service');
      const items=cart.items.filter(i=>i.properties?._ots_print_role==='service'&&i.properties._ots_print_bundle&&i.properties._ots_print_signature);
      const keys=new Set(items.map(i=>i.key));
      document.querySelectorAll('[data-ots-photo-v2-hidden-for]').forEach(row=>{
        const key=row.dataset.otsPhotoV2HiddenFor;
        if(!keys.has(key)||!detailsFor(key).includes(row.closest('.cart-item__details'))){
          row.hidden=false;delete row.dataset.otsPhotoV2HiddenFor;
        }
      });
      document.querySelectorAll('.ots-photo-v2-cart-preview').forEach(box=>{
        if(!keys.has(box.dataset.lineKey)||!detailsFor(box.dataset.lineKey).includes(box.parentElement))box.remove();
      });
      const needed=[];
      for(const item of items){
        const details=detailsFor(item.key);if(!details.length)continue;
        details.forEach(d=>simplifyDetails(d,item));
        const cached=previewCache.get(identity(item));
        if(cached){details.forEach(d=>showPreview(d,item,cached));continue;}
        for(const d of details){const box=previewBox(d,item);box.textContent='Loading print preview…';box.setAttribute('aria-live','polite');}
        needed.push(item);
      }
      for(let offset=0;offset<needed.length;offset+=10){
        const batch=needed.slice(offset,offset+10);
        let results;
        try{
          const r=await fetch(config.api.replace(/\/$/,'')+'/api/photo-v2/cart/previews',{
            method:'POST',credentials:'omit',headers:{'content-type':'application/json'},signal:AbortSignal.timeout(20000),
            body:JSON.stringify({shop:config.shop,items:batch.map(({key,product_id,variant_id,quantity,properties})=>({key,product_id,variant_id,quantity,
              properties:{_ots_print_role:properties._ots_print_role,_ots_print_bundle:properties._ots_print_bundle,_ots_print_signature:properties._ots_print_signature}}))})});
          const data=await r.json();if(!r.ok||!Array.isArray(data.previews))throw Error('Preview unavailable.');results=data.previews;
        }catch{results=[];}
        if(version!==refreshVersion)return;
        for(const item of batch){
          const result=results.find(p=>p.key===item.key)||{error:'Print preview unavailable. Please retry or contact us before ordering.'};
          if(!result.error){if(previewCache.size>=100)previewCache.clear();previewCache.set(identity(item),result);}
          detailsFor(item.key).forEach(d=>showPreview(d,item,result));
        }
      }
    }catch{
      if(version!==refreshVersion)return;
      // Keep existing verified thumbnails on transient cart failures. Normal
      // cart/engraving functions are never replaced by this optional renderer.
      document.querySelectorAll('.ots-photo-v2-cart-preview').forEach(box=>{
        if(!box.querySelector('img'))box.textContent='Print preview unavailable. Refresh the cart to retry.';
      });
    }
  }
  new MutationObserver(records=>{
    if(records.some(r=>[...r.addedNodes,...r.removedNodes].some(n=>n.nodeType===1&&(n.matches('.cart-item,cart-items,cart-drawer')||n.querySelector('.cart-item')))))schedulePreviews();
  }).observe(document.body,{childList:true,subtree:true});
  document.addEventListener('cart:updated',schedulePreviews);
  document.addEventListener('shopify:section:load',schedulePreviews);
  schedulePreviews();
  // Full cart navigation after adding photos gives Liquid a fresh hasPhotos value.
})();
